//#region
import axios from 'axios';
import { url, endPoint } from '../urls';
//#endregion

export const addFolder = (params) => {
    let _url = url.backendHost + endPoint.reportFolder.addFolder;
    return axios.post(_url, params);
}

export const updateFolder = (params) => {
    let _url = url.backendHost + endPoint.reportFolder.updateFolder;
    return axios.post(_url, params);
}

export const deleteFolder = (params) => {
    let _url = url.backendHost + endPoint.reportFolder.deleteFolder;
    return axios.post(_url, params);
}

export const addReportToFolder = (params) => {
    let _url = url.backendHost + endPoint.reportFolder.addReportToFolder;
    return axios.post(_url, params);
}

export const getAllFolders = (params) => {
    let _url = url.backendHost + endPoint.reportFolder.getAllFolders;
    return axios.post(_url, params);
}